<template>
  <div class="channel-withdrawal">
    <!-- 页面头部 -->
<!--    <div class="page-header">-->
<!--      <div class="header-left">-->
<!--        <h2 class="page-title"><i class="el-icon-s-finance"></i> 提现管理</h2>-->
<!--        <span class="page-desc">管理渠道提现申请、审核流程及提现规则配置</span>-->
<!--      </div>-->
<!--      <div class="header-right">-->
<!--        <el-button icon="el-icon-refresh" size="small" @click="handleRefresh">刷新</el-button>-->
<!--      </div>-->
<!--    </div>-->

    <!-- Tab标签页 -->
    <div class="section-title"><i class="el-icon-s-finance"></i> 提现管理</div>
    <el-card shadow="never" class="main-card">
      <el-tabs v-model="activeTab" @tab-click="handleTabClick" class="withdrawal-tabs">
        <el-tab-pane name="overview">
          <span slot="label"><i class="el-icon-data-analysis"></i> 提现概览</span>
          <withdrawal-overview ref="withdrawalOverview" :channel-id="searchForm.channelId"></withdrawal-overview>
        </el-tab-pane>
        <el-tab-pane name="audit">
          <span slot="label"><i class="el-icon-finished"></i> 提现审核</span>
          <withdrawal-audit ref="withdrawalAudit" :channel-id="searchForm.channelId"></withdrawal-audit>
        </el-tab-pane>
        <el-tab-pane name="rule">
          <span slot="label"><i class="el-icon-setting"></i> 提现规则</span>
          <withdrawal-rule ref="withdrawalRule"></withdrawal-rule>
        </el-tab-pane>
      </el-tabs>
    </el-card>

    <!-- 机构规则配置对话框 -->
    <org-rule-dialog
      :visible.sync="orgRuleDialogVisible"
      :organization-list="organizationList"
      :org-rule-list="orgRuleList"
      :form-data="orgRuleForm"
      @save-success="handleSaveOrgRule">
    </org-rule-dialog>
  </div>
</template>

<script>
import WithdrawalRule from './components/withdrawalRule.vue'
import OrgRuleDialog from './components/orgRuleDialog.vue'
import WithdrawalAudit from './components/withdrawalAudit.vue'
import WithdrawalOverview from './components/withdrawalOverview.vue'

export default {
  name: 'channelWithdrawal',
  components: {
    WithdrawalRule,
    OrgRuleDialog,
    WithdrawalAudit,
    WithdrawalOverview
  },
  data() {
    return {
      activeTab: 'overview',
      searchForm: {
        channelId: this.$route.query.channelId ? Number(this.$route.query.channelId) : null
      },
      // 机构规则相关
      organizationList: [],
      orgRuleList: [],
      orgRuleDialogVisible: false,
      orgRuleForm: null
    }
  },
  created() {
    this.loadOrganizationList()
    // this.loadOrgRuleList()
  },
  methods: {
    handleRefresh() {
      if (this.activeTab === 'overview' && this.$refs.withdrawalOverview) {
        this.$refs.withdrawalOverview.refresh()
      } else if (this.activeTab === 'audit' && this.$refs.withdrawalAudit) {
        this.$refs.withdrawalAudit.refresh()
      } else if (this.activeTab === 'rule' && this.$refs.withdrawalRule) {
        this.$refs.withdrawalRule.refresh()
      }
    },
    handleTabClick(tab) {
      if (tab.name === 'rule') {
        this.$nextTick(() => {
          if (this.$refs.withdrawalRule) {
            this.$refs.withdrawalRule.refresh()
          }
        })
      } else if (tab.name === 'overview') {
        this.$nextTick(() => {
          if (this.$refs.withdrawalOverview) {
            this.$refs.withdrawalOverview.refresh()
          }
        })
      } else if (tab.name === 'audit') {
        this.$nextTick(() => {
          if (this.$refs.withdrawalAudit) {
            this.$refs.withdrawalAudit.refresh()
          }
        })
      }
    },
    // 机构列表
    async loadOrganizationList() {
      const res = await this.$axios.get('/api/v1/manage/organization/queryByAdminId')
      if (res && res.code === 1) {
        this.organizationList = res.data || []
      }
    },
    // 机构规则列表
    async loadOrgRuleList() {
      const res = await this.$axios.get('/api/v1/channel/withdrawal/orgRules')
      if (res && res.code === 1) {
        this.orgRuleList = res.data || []
      }
    },
    // 新增机构规则
    handleAddOrgRule() {
      this.orgRuleDialogTitle = '新增机构规则'
      this.orgRuleForm = {
        id: null,
        organizationId: '',
        minAmount: 100,
        maxAmount: 10000,
        feeRate: 0.6,
        dailyLimit: 3,
        arrivalDays: 0,
        enabled: true
      }
      this.orgRuleDialogVisible = true
      this.$nextTick(() => {
        this.$refs.orgRuleForm && this.$refs.orgRuleForm.clearValidate()
      })
    },
    // 编辑机构规则
    handleEditOrgRule(rule) {
      this.orgRuleDialogTitle = '编辑机构规则'
      this.orgRuleForm = { ...rule }
      this.orgRuleDialogVisible = true
    },
    // 保存机构规则
    handleSaveOrgRule(ruleData) {
      if (ruleData.id) {
        // 更新
        const index = this.orgRuleList.findIndex(r => r.id === ruleData.id)
        if (index > -1) {
          this.orgRuleList.splice(index, 1, ruleData)
        }
      } else {
        // 新增
        ruleData.id = Date.now()
        this.orgRuleList.push(ruleData)
      }
      
      this.$message.success('保存成功')
    },
    // 切换机构规则状态
    handleToggleOrgRule(rule) {
      this.$message.success(rule.enabled ? '已启用该机构规则' : '已禁用该机构规则')
    },
    // 删除机构规则
    handleDeleteOrgRule(rule, index) {
      this.$confirm('确定要删除该机构的提现规则吗？删除后将使用全局规则', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.orgRuleList.splice(index, 1)
        this.$message.success('删除成功')
      }).catch(() => {})
    },
  },
  computed: {
  }
}
</script>

<style lang="less" scoped>
@import '../channel.less';

// 页面容器
.channel-withdrawal {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

// 主卡片
.main-card {
  flex: 1;
  overflow: hidden;
  /deep/ .el-card__body { padding: 0; height: 100%; }
}

// Tab样式
.withdrawal-tabs {
  height: 100%;
  display: flex;
  flex-direction: column;

  /deep/ .el-tabs__header {
    margin: 0;
    padding: 0 16px;
    border-bottom: 1px solid #EBEEF5;
    flex-shrink: 0;
  }

  /deep/ .el-tabs__nav-wrap::after { display: none; }

  /deep/ .el-tabs__content {
    flex: 1;
    overflow: hidden;
  }

  /deep/ .el-tab-pane {
    height: 100%;
    overflow-y: auto;
    padding: 16px;
    box-sizing: border-box;
    background: #f5f7fa;
  }
}

// 规则容器
.rule-container {
  .rule-alert {
    margin-bottom: 16px;
    
    p {
      margin: 4px 0;
      font-size: 12px;
    }
  }
}

// 规则卡片
.rule-card {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  height: 100%;
  min-height: 500px;
  
  .rule-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding-bottom: 16px;
    border-bottom: 1px solid #EBEEF5;
    
    .rule-title {
      display: flex;
      align-items: center;
      font-size: 16px;
      font-weight: 600;
      color: #303133;
      
      i {
        margin-right: 8px;
        font-size: 18px;
      }
    }
  }
  
  &.global-rule {
    .rule-title i {
      color: #409EFF;
    }
  }
  
  &.org-rule {
    .rule-title i {
      color: #E6A23C;
    }
  }
}

// 表单分区
.form-section {
  margin-bottom: 20px;
  
  .section-title {
    font-size: 13px;
    font-weight: 600;
    color: #606266;
    margin-bottom: 12px;
    padding-left: 10px;
    border-left: 3px solid #409EFF;
  }
}

// 表单操作
.form-actions {
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #EBEEF5;
}

// 规则预览
.rule-preview {
  margin-top: 20px;
  padding: 16px;
  background: linear-gradient(135deg, #f5f7fa 0%, #fff 100%);
  border-radius: 8px;
  border: 1px dashed #DCDFE6;
  
  .preview-title {
    font-size: 13px;
    font-weight: 600;
    color: #303133;
    margin-bottom: 12px;
  }
  
  .preview-example {
    display: flex;
    align-items: center;
    gap: 16px;
    font-size: 13px;
    color: #606266;
    
    strong {
      font-size: 15px;
    }
    
    .text-warning {
      color: #E6A23C;
    }
    
    .text-success {
      color: #67C23A;
    }
  }
}

// 机构规则列表
.org-rule-list {
  max-height: 400px;
  overflow-y: auto;
}

.org-rule-item {
  padding: 16px;
  margin-bottom: 12px;
  background: #fafafa;
  border-radius: 8px;
  border: 1px solid #EBEEF5;
  transition: all 0.3s;
  
  &:hover {
    border-color: #409EFF;
    box-shadow: 0 2px 8px rgba(64, 158, 255, 0.1);
  }
  
  &:last-child {
    margin-bottom: 0;
  }
  
  .org-rule-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    
    .org-info {
      display: flex;
      align-items: center;
      gap: 10px;
      
      .org-status {
        font-size: 12px;
        
        &.enabled {
          color: #67C23A;
        }
        &.disabled {
          color: #909399;
        }
      }
    }
    
    .org-actions {
      display: flex;
      align-items: center;
      gap: 8px;
    }
  }
  
  .org-rule-content {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
    
    .rule-item {
      display: flex;
      justify-content: space-between;
      padding: 8px 12px;
      background: #fff;
      border-radius: 4px;
      
      .rule-label {
        font-size: 12px;
        color: #909399;
      }
      
      .rule-value {
        font-size: 13px;
        font-weight: 500;
        color: #303133;
      }
    }
  }
}

// 对话框预览
.dialog-preview {
  margin-top: 16px;
  padding: 12px 16px;
  background: #f5f7fa;
  border-radius: 6px;
  
  .preview-title {
    font-size: 13px;
    font-weight: 600;
    color: #303133;
    margin-bottom: 8px;
    
    i {
      margin-right: 6px;
      color: #409EFF;
    }
  }
  
  .preview-content {
    font-size: 13px;
    color: #606266;
    
    p {
      margin: 0;
    }
    
    .text-warning {
      color: #E6A23C;
    }
    
    .text-success {
      color: #67C23A;
    }
  }
}

// 文字颜色
.text-danger {
  color: #F56C6C !important;
}
</style>
